import { Grid } from "@material-ui/core";
import { observer } from "mobx-react";
import React, { memo, useEffect } from "react";
import { useStore } from "app/stores";
import ListServiceBlock from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/GeneralInfomationTab/ListServiceBlock";
import ListTreatmentPlanBlock from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/GeneralInfomationTab/ListTreatmentPlanBlock";
import ListServiceRequestItemBlock from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/GeneralInfomationTab/ListServiceRequestItemBlock";
import ListRecentDiagnosticReportImages from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/GeneralInfomationTab/ListRecentDiagnosticReportImages";
import ListVoucherPayment from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/GeneralInfomationTab/ListVoucherPayment";
import ListProductDrug from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/GeneralInfomationTab/ListProductDrugBlock";
const TreamentGeneralInfo = () => {
  const { handleGetPatientOverviewById, initialPatient, setCurrentTab } =
    useStore().patientManagementStore.patientGeneralStore;
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");

  const { handleOpenCreateOrEditServicePopup } =
    useStore().patientManagementStore.registerServiceStore;
  useEffect(() => {
    if (patientId) {
      handleGetPatientOverviewById(patientId);
    }
  }, [patientId]);

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} lg={6}>
          <ListServiceRequestItemBlock
            initialPatient={initialPatient}
            setCurrentTab={setCurrentTab}
            handleAfterSubmit={async () => {
              setTimeout(() => {
                handleGetPatientOverviewById(patientId);
              }, 500);
            }}
          />
        </Grid>

        {/* ảnh điều trị */}
        <Grid item xs={12} lg={6}>
          <ListRecentDiagnosticReportImages setCurrentTab={setCurrentTab} />
        </Grid>

        {/*Payment*/}
        <Grid item xs={12} lg={6}>
          <ListVoucherPayment
            initialPatient={initialPatient}
            setCurrentTab={setCurrentTab}
          />
        </Grid>
        {/* Danh sách thẻ liệu trình*/}
        {/* <Grid item xs={12} lg={6}>
          <ListTreatmentPlanBlock
            initialPatient={initialPatient}
            setCurrentTab={setCurrentTab}
            handleAfterSubmit={async () => {
              setTimeout(() => {
                handleGetPatientOverviewById(patientId);
              }, 500);
            }}
          />
        </Grid> */}
        {/* Danh sách dịch vụ*/}
        <Grid item xs={12} lg={6}>
          <ListServiceBlock
            initialPatient={initialPatient}
            setCurrentTab={setCurrentTab}
            handleOpenCreateOrEditServicePopup={
              handleOpenCreateOrEditServicePopup
            }
            handleAfterSubmit={async () => {
              setTimeout(() => {
                handleGetPatientOverviewById(patientId);
              }, 500);
            }}
          />
        </Grid>

        <Grid item xs={12} lg={6}>
          <ListProductDrug
            initialPatient={initialPatient}
            setCurrentTab={setCurrentTab}
            handleAfterSubmit={async () => {
              setTimeout(() => {
                handleGetPatientOverviewById(patientId);
              }, 500);
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default memo(observer(TreamentGeneralInfo));
